import { render, staticRenderFns } from "./updatePriceModal.vue?vue&type=template&id=8f68b8de&scoped=true&"
import script from "./updatePriceModal.vue?vue&type=script&lang=js&"
export * from "./updatePriceModal.vue?vue&type=script&lang=js&"
import style0 from "./updatePriceModal.vue?vue&type=style&index=0&id=8f68b8de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f68b8de",
  null
  
)

export default component.exports